export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
export const MAX_IMAGES = 20;

export const REQUIRED_BANNER_WIDTH = 1920;
export const REQUIRED_BANNER_HEIGHT = 1080;